import React from "react";
import BaseModal from "../BaseModal";
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {actionChangeStatusShowModalOrderDetails} from "../../../../../redux/actions/modals/modalOrderDetails/modalOrderDetails";
import CardItemModalBasketCartProduct from "../../card/CardItemModalBasketCartProduct";

import Steps, {Step} from "rc-steps";
import {FaCheck, FaTimes} from "react-icons/all";

const ModalOrderDetails = () => {
    const dispatch = useDispatch();
    const {statusShow, order} = useSelector(state => state.modalOrderDetails);
    const handleClose = () => {
        dispatch(actionChangeStatusShowModalOrderDetails(false));
    };
    return (
        <>
            <BaseModal title={'جزییات سفارش'}
                       show={statusShow}
                       dialogClassName={''}
                       handleClose={handleClose}>
                <Modal.Body>
                    {typeof order.order_status !== "undefined" && order.order_status.length > 0 ?
                        <>
                            <ul className={'list-ul-modal-invoice'}>
                                <li className={'item-li-modal-invoice'}>
                                    <div className={'head-item-li-modal-invoice'}>
                                        <h6>وضعیت سفارش</h6>
                                    </div>
                                    <div style={{fontSize: 6, display: "flex"}}>
                                        <Steps size={'small'} icons={{
                                            finish: <FaCheck/>,
                                            error: <FaTimes/>
                                        }} status={`process`} initial={0} labelPlacement={`vertical`}
                                               iconPrefix={' glyphicon glyphicon-cloud '}>
                                            {order.order_status.map((item, index) => {
                                                return (
                                                    <Step key={index} title={<span>{item.title}</span>}
                                                         status={item.done ? 'finish' :'wait' }
                                                          disabled={!item.done}
                                                          active={item.done}
                                                    />
                                                );
                                            })}
                                        </Steps>
                                    </div>
                                </li>
                            </ul>
                            <hr />
                        </>
                    : ''}
                    <div style={{padding: '0 20px'}}>
                        {order.basket !== undefined ? order.basket.map((product, index) => {
                            return (
                                <CardItemModalBasketCartProduct
                                    key={index}
                                    data={{
                                        product: {
                                            name: product.title,
                                            image: product.image,
                                            unit: product.amount,
                                            price: product.price,
                                            gradeTitle: product.grade_title
                                        }
                                    }}
                                    showEdit={false}/>
                            );
                        }) : ''}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className={'w-100'}>
                        <div className={'cm-btn-data-modal-order-details'}>
                            <div>
                                <ul>
                                    {order.delivery_price > 0 ?
                                        <li>
                                            <span>خرید جمع آوری و ارسال </span>
                                            <span>{parseInt(order.delivery_price).toLocaleString()}</span>
                                        </li>
                                        : null}

                                    <li>
                                        <span>تخفیف </span>
                                        <span>{parseInt(order.discount).toLocaleString()}</span>
                                    </li>

                                    {order.question_price > 0 ?
                                        <li>
                                            <span>خدمات دیگر </span>
                                            <span>{parseInt(order.question_price).toLocaleString()}</span>
                                        </li>
                                        : null}
                                </ul>
                            </div>
                            <div>
                                <div>
                                    <span>مبلغ کل </span>
                                    <span>{parseInt(order.total_price).toLocaleString()}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </BaseModal>
        </>
    )
};
export default ModalOrderDetails;
